import Image from "next/image";
import Link from "next/link";

import AboutData from "../../data/elements/about.json";

import { useParallax } from "react-scroll-parallax";


import { image_url } from "@/helper/Utilities";
import { ROUTE } from "@/route/app_routes.js";


import aboutImg1 from "@/public/app_images/about/about1.webp";
import aboutImg2 from "@/public/app_images/about/about2.webp";
import aboutImg3 from "@/public/app_images/about/about3.webp";




const AboutTwo = () => {


  const { ref: ref1, style: style1 } = useParallax({
    translateY: [0, -20],
  });

  const { ref: ref2, style: style2 } = useParallax({
    translateY: [0, 20],
  });

  const { ref: ref3, style: style3 } = useParallax({
    translateY: [0, 20],
  });



  return (
    <>
      {AboutData &&
        AboutData.aboutTwo.map((data, index) => (
          <div className="row g-5 align-items-center" key={index}>
            <div className="col-lg-6">
              <div className="thumbnail-wrapper">

                <div className="thumbnail-wrapper">
                  <div className={`thumbnail image-1`} ref={ref1} style={style1}>
                    <Image src={aboutImg1} width={366} height={490} alt="Education Images" />
                  </div>
                  <div className={`thumbnail image-2`} ref={ref2} style={style2}>
                    <Image src={aboutImg2} width={308} height={250} alt="Education Images" />
                  </div>
                  <div className={`thumbnail image-3`} ref={ref3} style={style3}>
                    <Image src={aboutImg3} width={405} height={490} alt="Education Images" />
                  </div>
                </div>
                {/* {data.images.map((img) => (
                  <div
                    className={`thumbnail image-${img.id} ${img.class}`}
                    key={img.id}
                  >
                    <Image
                      data-parallax='{"x": 0, "y": -20}'
                      src={img.image}
                      width={img.width}
                      height={img.height}
                      alt="Education Images"
                    />
                  </div>
                ))} */}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inner pl--50 pl_sm--0 pl_md--0">
                <div className="section-title text-start">
                  <span className="subtitle bg-coral-opacity">{data.tag}</span>
                  <h2 className="title">
                    Free Courses, <br /> Real Skills
                  </h2>
                </div>

                <p className="description mt--30">
                  SmartTech Academy is a free online school built to make tech education accessible to anyone, anywhere &mdash; no tuition, no paywalls.
                </p>

                <div className="rbt-feature-wrapper mt--20 ml_dec_20">

                  <div className="rbt-feature feature-style-2 rbt-radius" key="1">
                    <div className={`icon ${"bg-primary-opacity"}`}>
                      <i className="feather-monitor"></i>
                    </div>
                    <div className="feature-content">
                      <h6 className="feature-title">Project-Based Courses</h6>
                      <p className="feature-description">
                        Structured, hands-on curriculum across web development, software engineering, and more &mdash; built around real projects, not just theory.
                      </p>
                    </div>
                  </div>

                  <div className="rbt-feature feature-style-2 rbt-radius" key="2">
                    <div className={`icon ${"bg-pink-opacity"}`}>
                      <i className="feather-book"></i>
                    </div>
                    <div className="feature-content">
                      <h6 className="feature-title">Learn at Your Own Pace</h6>
                      <p className="feature-description">
                        Self-paced video lessons, quizzes, and assignments you can complete on your schedule, from any device.
                      </p>
                    </div>
                  </div>

                </div>

                <p className="description mt--30">
                  Our mission is simple: remove cost as a barrier to learning tech skills, and give every learner a clear path from beginner to job-ready.
                </p>

                <div className="about-btn mt--40">
                  <Link className="rbt-btn btn-gradient hover-icon-reverse" href={ROUTE.about}>
                    <span className="icon-reverse-wrapper">
                      <span className="btn-text">More About Us</span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default AboutTwo;
